import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw3-grid tw3-gap-1.5" }
const _hoisted_2 = { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }

import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import Textarea from 'primevue/textarea';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingField',
  props: {
    label: {},
    modelValue: { default: '' },
    error: { default: '' },
    type: { default: 'text' },
    placeholder: { default: '' },
    autocomplete: { default: '' },
    rows: { default: 4 }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    (_ctx.type === 'textarea')
      ? (_openBlock(), _createBlock(_unref(Textarea), {
          key: 0,
          fluid: "",
          invalid: !!_ctx.error,
          modelValue: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          rows: _ctx.rows,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event ?? '')))
        }, null, 8, ["invalid", "modelValue", "placeholder", "rows"]))
      : (_openBlock(), _createBlock(_unref(InputText), {
          key: 1,
          autocomplete: _ctx.autocomplete,
          fluid: "",
          invalid: !!_ctx.error,
          modelValue: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          type: _ctx.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event ?? '')))
        }, null, 8, ["autocomplete", "invalid", "modelValue", "placeholder", "type"])),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 2,
          severity: "error",
          size: "small",
          variant: "simple"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})